jQuery(document).ready(function($) {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

  if ($(window).width() < 780) {
    var pauseOnHover = false;
  } else {
    var pauseOnHover = true;
  }

  $('.hungry-carousel__items-group').flickity({
    prevNextButtons: false,
    pageDots: true,
    freeScroll: false,
    wrapAround: true,
    autoPlay: 5000,
    draggable: pauseOnHover,
    pauseAutoPlayOnHover: pauseOnHover
  });

    $('.instagram-pics').flickity({
      contain: true,
      percentPosition: false,
      prevNextButtons: false,
      pageDots: false,
      freeScroll: true,
    });
    $(".to-top").click(function() {
      $("html, body").animate({ scrollTop: 0 }, 800);
      return false;
    });

  $("#searchsubmit:not(.mobile-search-submit)").click(function() {
    $(this).parent(".container-2").toggleClass("click-class");
    $(this).find(".fa").toggleClass("fa-times");
    $(this).find(".fa").toggleClass("fa-search");
  });


  if($(".hungry-blog--style-carousel").size() > 0) {
    $(".hungry-blog--style-carousel").css({
      opacity : 1,
      "visibility" : "visible"
    })
  }

  if($("#null-instagram-feed-2").size() > 0) {
    $("#null-instagram-feed-2").css({
      opacity: 1,
      "visibility": "visible"
    })
  }


  if ($("#og-grid li").size() > 0) {

      $(window).load(function() {
          $("#og-grid li").fadeIn(1200);
          // var mincount = 0;
          // var maxcount = 3;
          // var eT = 0;
          // $("#og-grid li").each(function(index) {
          //     $("#og-grid li").slice(mincount,maxcount).delay(eT*index).animate({
          //         opacity: 1,
          //     }, 1200)
          //     // $(this).delay(eT*index).fadeIn('slow');
          //     eT += 200;
          //     mincount = mincount+1;
          //     maxcount = maxcount+3;
          // });

      });



  }

});
